import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export const formatDate = (dateString: string) => {
  if (!dateString) return "غير متوفر";

  const date = new Date(dateString);
  return new Intl.DateTimeFormat("ar-us", {
    timeZone: "Africa/Cairo",
    weekday: "long",
    month: "long",
    day: "2-digit",
  }).format(date);
};

export const formatTime = (timeString: string) => {
  if (!timeString) return "غير متوفر";

  const date = new Date(timeString);
  return new Intl.DateTimeFormat("ar-us", {
    timeZone: "Africa/Cairo",
    hour: "2-digit",
    minute: "2-digit",
    // second: "2-digit",
  }).format(date);
};

export const formatTimeNow = () => {
  const date = new Date();
  date.setMinutes(date.getMinutes() - 1);
  return new Intl.DateTimeFormat("ar-us", {
    timeZone: "Africa/Cairo",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    hour12: false,
  }).format(date);
};

export const formatEGP = (value: number) => {
  if (!value) return "___";
  return new Intl.NumberFormat("eg-EG", {
    style: "currency",
    currency: "EGP",
    minimumFractionDigits: 0,
  }).format(value);
};
